import * as d3Fetch from 'd3-fetch'

const stringFields = ['iso', 'country', 'region', 'region_world_bank', 'port']

const stringify = (d) => {
  for (var i in d) {
    if (!stringFields.includes(i)) {
      d[i] = +d[i]
    }

    if (i === 'value') {
      d.value_formatted = formatScore(d[i])
    }
  }
  return d
}

function parseData({ src }) {
  const countriesPromise = d3Fetch.csv(src.countries, stringify)
  const portsPromise = d3Fetch.csv(src.ports, stringify)

  let data = Promise.all([countriesPromise, portsPromise]).then((res) => {
    const [countriesData, portsData] = res

    let dataset = {
      countries: new Map(),
      ports: portsData.sort((a, b) => b.index - a.index),
    }

    countriesData.sort((a, b) => a.country.localeCompare(b.country))

    countriesData.forEach((country) => {
      const { iso } = country
      const ports = dataset.ports.filter((p) => p.iso === iso)
      const numPorts = ports.length

      if (numPorts === 0) {
        return
      }

      dataset.countries.set(iso, {
        num_ports: numPorts,
        least_port: ports[numPorts - 1],
        most_port: ports[0],
        ...country,
      })
    })

    return dataset
  })

  return data
}

function formatScore(value) {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
}

export default parseData
